import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { PLAN_OPTIONS } from "./constants";
import { Gift, Loader2 } from "lucide-react";

export default function GrantModal({ user, plan, onPlanChange, days, onDaysChange, granting, onConfirm, onClose }) {
  return (
    <Dialog open={!!user} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="glass-card text-slate-100 sm:max-w-md" data-testid="admin-grant-modal">
        <DialogHeader>
          <DialogTitle className="font-heading text-lg font-bold text-slate-100 flex items-center gap-2">
            <Gift className="w-5 h-5 text-cyan-400" /> Conceder acesso cortesia/teste
          </DialogTitle>
        </DialogHeader>
        <DialogDescription className="text-sm text-slate-400">Ativa o plano de <span className="text-slate-200 font-semibold">{user?.name}</span> sem gerar cobrança na InfinitePay.</DialogDescription>
        <div className="space-y-3 mt-2">
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-slate-400">Plano</label>
            <Select value={plan} onValueChange={onPlanChange}>
              <SelectTrigger data-testid="admin-grant-plan-select" className="bg-slate-800/60 border-slate-700 text-slate-100 mt-1">
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="bg-slate-900 border-slate-700 text-slate-100">
                {PLAN_OPTIONS.map((p) => (
                  <SelectItem key={p.value} value={p.value}>{p.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-slate-400">Dias de teste (0 = sem vencimento)</label>
            <Input type="number" min={0} max={365} value={days} onChange={(e) => onDaysChange(e.target.value)}
              data-testid="admin-grant-days-input"
              className="bg-slate-800/60 border-slate-700 text-slate-100 font-mono mt-1" />
          </div>
          <Button onClick={onConfirm} disabled={granting} data-testid="admin-grant-confirm"
            className="w-full bg-cyan-500 hover:bg-cyan-600 text-cyan-950 font-semibold">
            {granting ? <Loader2 className="w-4 h-4 animate-spin" /> : "Conceder acesso sem cobrança"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
